import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon, WrenchIcon } from 'lucide-react';
import { Panel, PanelEmpty, rowClass } from './Panel';
import { StatusBadge } from '../StatusBadge';
import { cityFromAddress, relativeUpcoming } from '../../../utils/adminDates';
import type { Case } from '../../../types/admin';
function thumbnail(item: Case): string | undefined {
  const preferred = item.photos.find(photo => photo.stage === 'Under arbejdet') ?? item.photos.find(photo => photo.stage === 'Før') ?? item.photos[0];
  return preferred?.url || undefined;
}
export function ActiveCasesPanel({
  cases
}: {
  cases: Case[];
}) {
  return <Panel title="Aktive sager" linkLabel="Se alle" linkTo="/admin/sager" data-id="element-151" data-mp="1jki90i4pi3pv">
      {cases.length === 0 ? <PanelEmpty data-id="element-152" data-mp="19o5i1s0jq3yt">Ingen aktive sager lige nu.</PanelEmpty> : <ul className="divide-y divide-line/70" data-id="element-153" data-mp="19oxcv0mbjxo1">
          {cases.map(item => {
        const image = thumbnail(item);
        const city = cityFromAddress(item.address);
        return <li key={item.id} data-id="element-154" data-mp="k9e8lt6z8ptj">
                <Link to={`/admin/sager/${item.id}`} className={rowClass} data-id="element-155" data-mp="f8gq1fi21tri">
                  <span className="h-12 w-16 shrink-0 overflow-hidden rounded-lg border border-line bg-canvas-deep" data-id="element-156" data-mp="faksru47wmq7">
                    {image ? <img src={image} alt="" className="h-full w-full object-cover" loading="lazy" data-id="element-157" data-mp="p7fsggc88t62" /> : <span className="flex h-full w-full items-center justify-center text-ink-faint" data-id="element-158" data-mp="1h1xagycie79">
                        <WrenchIcon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" data-id="element-159" data-mp="3soxuu898d7z3" />
                      </span>}
                  </span>
                  <span className="min-w-0 flex-1" data-id="element-160" data-mp="5hcaadkk24vm">
                    <span className="block truncate text-[15px] font-semibold text-ink" data-id="element-161" data-mp="3dy76xbaret19">{item.title}</span>
                    <span className="block truncate text-sm text-ink-muted" data-id="element-162" data-mp="39wvd0tkurln9">
                      {[item.customerName, city].filter(Boolean).join(' · ')}
                    </span>
                  </span>
                  <StatusBadge status={item.status} className="hidden sm:inline-flex" data-id="element-163" data-mp="1huspi82lu5lj" />
                  <span className="hidden w-20 shrink-0 text-right text-sm text-ink-muted md:block" data-id="element-164" data-mp="1mlsi514oy1i8">
                    {item.plannedDate ? relativeUpcoming(item.plannedDate) : '—'}
                  </span>
                  <ChevronRightIcon className="h-4 w-4 shrink-0 text-ink-faint transition-colors duration-150 group-hover:text-accent" aria-hidden="true" data-id="element-165" data-mp="txd8ku4bwbea" />
                </Link>
              </li>;
      })}
        </ul>}
    </Panel>;
}